import axios from 'axios';
import {REP_API_URL} from '../utils/constants.js';

class QuoteMeService {
    async getCustomerMultipliers(data){
        //const REP_API_URL = 'http://127.0.0.1:8000/rep-portal-api/'
		const url = `${REP_API_URL}get-company-products`;
		const headers = {
			'Content-Type': 'application/json'
		};
		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			data: formData,
			headers: headers
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});
	}

	async getNextQuoteOrderNumber(){
        //const REP_API_URL = 'http://127.0.0.1:8000/rep-portal-api/'
		const url = `${REP_API_URL}get-next-quote-number`;
		const headers = {
			'Content-Type': 'application/json'
		};
		return axios({
			url:url,
			method: 'GET',
			headers: headers
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});
	}

	async saveQuoteData(data){
        //const REP_API_URL = 'http://127.0.0.1:8000/rep-portal-api/'
		const url = `${REP_API_URL}save-quote-data`;
		const headers = {
			'Content-Type': 'application/json'
		};
		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			data: formData,
			headers: headers
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});
	}

	async getQuoteHistory(data){
        //const REP_API_URL = 'http://127.0.0.1:8000/rep-portal-api/'
		const url = `${REP_API_URL}get-quote-history`;
		const headers = {
			'Content-Type': 'application/json'
		};
		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			headers: headers,
			data: formData
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});
	}

	async getQuoteDetails(data){
        //const REP_API_URL = 'http://127.0.0.1:8000/rep-portal-api/'
		const url = `${REP_API_URL}get-quote-details`;
		const headers = {
			'Content-Type': 'application/json'
		};

		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			headers: headers,
			data: formData
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});
	}

	async exportQuoteOrderPDF(data) {
		const url = `${REP_API_URL}export-quote-pdf`;

		return axios({
			url: url,
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			data: data,
			responseType: 'blob'
		});
	}

	async exportQuoteOrderExcel(data) {
		const url = `${REP_API_URL}export-quote-excel`;

		return axios({
			url: url,
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			data: data,
			responseType: 'blob'
		});
	}

	async shareQuote(payload){
		const url = `${REP_API_URL}share-quote-me/`;
		//const url = `http://127.0.0.1:8000/rep-portal-api/share-sales-trending-report/`;
		const headers = {
			'Content-Type': 'application/json',
		};
	
		return axios({
			url: url,
			method: 'POST',
			headers: headers,
			data: payload
		})
		.then(function (response) {
			return response;
		})
		.catch(function (error) {
			return error.response ? error.response.data : { error: 'Unknown error' };
		});
	}

	async updateQuoteData(data){
        //const REP_API_URL = 'http://127.0.0.1:8000/rep-portal-api/'
		const url = `${REP_API_URL}update-quote-data`;
		const headers = {
			'Content-Type': 'application/json'
		};
		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			data: formData,
			headers: headers
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});
	}
}

export default QuoteMeService;